module.exports = __webpack_public_path__ + "img/UFCW_Logo.248c98d7.png";